import { IPaymentMethod } from './IPaymentMethod';

export type PeriodType = `${Period}`;

export enum Period {
  EveryMonth = 'Month',
  EveryOtherMonth = 'EveryOtherMonth',
  EveryThirdMonth = 'EveryThirdMonth',
  EveryYear = 'Year',
  Once = 'Once',
}

export type PeriodOptions = Partial<{
  [key in Period]: {
    enabled?: boolean;
    order?: number;
  };
}>;

export type PurchaseProduct = {
  id: number;
  name?: string;
  slug?: string;
  publicName?: string;
  files?: {
    receipt: boolean;
    certificate: boolean;
  };
};

export type PaymentMethodOptions =
  | SwishPaymentMethodOptions
  | KlarnaPaymentsPaymentMethodOptions;

export type SwishPaymentMethodOptions = {
  returnUrl?: string;
  phoneNumber?: string;
  swishType: 'mcommerce' | 'ecommerce';
};

export type KlarnaPaymentsPaymentMethodOptions = {
  authorizationToken: string;
};

export type ProductOptions = {
  pul: boolean;
  customerContact?: CustomerContact;
  product: ProductOptionsProduct;
  collectionId?: number;
  campaignActivityId?: number;
  certificate?: {
    heading?: string;
  };
};

export type PurchaseSocial = {
  anonymous: boolean;
  profile?: {
    name?: string;
  };
};

export type PurchaseUser = {
  id: number;
  firstName?: string;
  lastName?: string;
  type?: string;
  image?: { url?: string };
};

export type CustomerContact = {
  firstName: string;
  lastName: string;
  ssn: string;
  cid: string;
  email: string;
  status: string;
  company: string;
  addressCo: string;
  addressZip: string;
  addressCity: string;
  phoneNumber: string;
  addressStreet: string;
  phoneNumberType: string;
};

export type ProductOptionsProduct = {
  price: number;
  period: PeriodType;
  quantity: number;
};

export type ClientOptions = {
  clientId?: string;
  gclId?: string;
  userId?: string;
};

export type PurchaseShare = {
  url?: string;
  texts?: {
    default?: string;
    mail?: string;
    twitter?: string;
    fb?: string;
  };
};

export type PurchasePurchase = {
  id: number;
  token: string;
  publicToken: string;
  periodicity: PeriodType;
  amount: number;
  paid: boolean;
  status: string;
  productOptions: ProductOptions;
  isSubscription?: boolean;
  hasActiveSubscription?: boolean;
  files?: {
    receipt?: string;
    certificate?: string;
  };
  klarnaRedirectUrl?: string;
  payment?: Payment;
  payments: Payment[];
};

type Payment = {
  id: number;
  state: 'pending' | 'paid' | 'filed' | 'failed';
  exceptionMessage?: any;
};

export type IMePurchase = {
  id: string;
  amount: string;
  product: PurchaseProduct;
  purchase: PurchasePurchase;
  files: {
    receipt?: string;
    certificate?: string;
  };
  paymentMethod: IPaymentMethod & {
    cardDetails?: {
      last4?: string;
      exp_month?: string;
      exp_year?: string;
    };
  };
  createdAt: string;
};
